/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import type { LocalViewId } from '@jira/polaris__domain-view/src/ViewKind.types.tsx';
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import type { Action } from '@atlassian/react-sweet-state';
import type { Props, State } from './NavigationView.types.tsx';
import { modifyView } from './updateContainerState.tsx';

export const renameView =
	(localId: LocalViewId): Action<State, Props> =>
	async ({ setState, getState }, props) => {
		const { navigationRemote, cloudId, containerId } = props;
		if (
			!cloudId ||
			!containerId ||
			!navigationRemote ||
			getState().containers[containerId]?.isLoading ||
			!getState().containers[containerId]?.initialized
		) {
			return;
		}
		setState(
			modifyView(getState(), containerId, (view) => {
				if (view.localId === localId) {
					return {
						...view,
						isRenaming: true,
					};
				}
				return view;
			}),
		);
	};

export const cancelViewRenaming =
	(localId: LocalViewId): Action<State, Props> =>
	async ({ setState, getState }, props) => {
		const { navigationRemote, cloudId, containerId } = props;
		if (
			!cloudId ||
			!containerId ||
			!navigationRemote ||
			getState().containers[containerId]?.isLoading ||
			!getState().containers[containerId]?.initialized
		) {
			return;
		}
		setState(
			modifyView(getState(), containerId, (view) => {
				if (view.localId === localId) {
					return {
						...view,
						isRenaming: false,
					};
				}
				return view;
			}),
		);
	};
